// extracted by mini-css-extract-plugin
module.exports = {"detail":"video_detail_detail__3dU0z","video":"video_detail_video__1xUFG","description":"video_detail_description__3092Z"};